// Single source of truth for all survey option questions.
// key   → stored in DB (never change these once data exists)
// label → shown to the user (safe to reword anytime)

export const Q5_OPTIONS = [
  { key: 'spend_under5k',  label: 'Under ₹5,000' },
  { key: 'spend_5_15k',    label: '₹5,000–15,000' },
  { key: 'spend_15_30k',   label: '₹15,000–30,000' },
  { key: 'spend_30_60k',   label: '₹30,000–60,000' },
  { key: 'spend_above60k', label: 'Above ₹60,000' },
];

export const Q6_OPTIONS = [
  { key: 'shock_always',    label: 'Almost always' },
  { key: 'shock_often',     label: 'Often' },
  { key: 'shock_sometimes', label: 'Sometimes' },
  { key: 'shock_rarely',    label: 'Rarely' },
  { key: 'shock_never',     label: 'Never' },
];

export const Q7_OPTIONS = [
  { key: 'saw_yes',     label: 'Yes — I had noticed something was off' },
  { key: 'saw_partial', label: 'Partially — something felt wrong but I ignored it' },
  { key: 'saw_no',      label: 'No — it came out of nowhere' },
  { key: 'saw_none',    label: "I haven't had a significant repair bill" },
];

export const Q8_OPTIONS = [
  { key: 'mech_always',    label: 'Almost always' },
  { key: 'mech_sometimes', label: 'Sometimes' },
  { key: 'mech_rarely',    label: 'Rarely' },
  { key: 'mech_never',     label: 'Never — I just pay and trust them' },
];

export const Q9_OPTIONS = [
  { key: 'overcharge_yes',   label: 'Yes, definitely' },
  { key: 'overcharge_maybe', label: "Suspected but couldn't verify" },
  { key: 'overcharge_no',    label: 'No' },
];

export const Q_MINDSET_OPTIONS = [
  { key: 'mindset_tool', label: "I treat my car as a tool — I just want it to work, I don't think about it much" },
  { key: 'mindset_resp', label: "I stay on top of maintenance but don't go deep into the technical side" },
  { key: 'mindset_know', label: "I'm fairly knowledgeable — I follow car content, understand what mechanics tell me" },
  { key: 'mindset_enth', label: "I'm an enthusiast — I actively learn about my car's performance and systems" },
];

export const Q10_OPTIONS = [
  { key: 'svc_schedule',  label: 'Fixed schedule (every X months or km)' },
  { key: 'svc_feels',     label: 'When something feels or sounds wrong' },
  { key: 'svc_light',     label: 'When a warning light appears' },
  { key: 'svc_reminded',  label: 'When a friend or family member reminds me' },
  { key: 'svc_booklet',   label: 'I follow the manufacturer booklet strictly' },
];

export const Q11_OPTIONS = [
  { key: 'first_ignore',   label: 'Ignore it and hope it goes away' },
  { key: 'first_friend',   label: 'Ask a friend or family member who knows cars' },
  { key: 'first_online',   label: 'Search online (Google, YouTube, forums)' },
  { key: 'first_mechanic', label: 'Go directly to a mechanic' },
  { key: 'first_service',  label: 'Call the service center' },
];

export const Q12_OPTIONS = [
  { key: 'bd_never', label: 'Never' },
  { key: 'bd_once',  label: 'Once' },
  { key: 'bd_twice', label: 'Twice' },
  { key: 'bd_more',  label: 'More than twice' },
];

export const Q14_OPTIONS = [
  { key: 'pri_cost',  label: "Avoiding unexpected repair costs — knowing what's coming before it hits you" },
  { key: 'pri_trust', label: "Feeling confident when dealing with mechanics — understanding what's wrong and whether you're being charged fairly" },
  { key: 'pri_rely',  label: "Knowing your car won't let you down — reliability and safety when you need it most" },
];

export const Q15_OPTIONS = [
  { key: 'wtp_none',  label: "Nothing — I'd rather deal with it when it happens" },
  { key: 'wtp_low',   label: 'A little — maybe ₹200–500 per year for peace of mind' },
  { key: 'wtp_mid',   label: 'Moderate — ₹500–1,500 per year' },
  { key: 'wtp_high',  label: 'Significant — ₹1,500–5,000 per year' },
  { key: 'wtp_vhigh', label: 'A lot — more than ₹5,000 per year if it reliably worked' },
];

export const Q16_OPTIONS = [
  { key: 'tool_yes', label: 'Yes' },
  { key: 'tool_no',  label: 'No' },
];

export const Q18_OPTIONS = [
  { key: 'disc_friend',  label: 'Recommendation from a friend' },
  { key: 'disc_forum',   label: 'Reading about it in a car forum or community' },
  { key: 'disc_service', label: 'Seeing it offered at my service center' },
  { key: 'disc_social',  label: 'Social media' },
  { key: 'disc_insure',  label: 'My insurance company offering it' },
];

export const Q19_OPTIONS = [
  { key: 'age_u25',   label: 'Under 25' },
  { key: 'age_25_35', label: '25–35' },
  { key: 'age_35_45', label: '35–45' },
  { key: 'age_45_55', label: '45–55' },
  { key: 'age_a55',   label: 'Above 55' },
];

export const Q20_OPTIONS = [
  { key: 'gen_m',    label: 'Male' },
  { key: 'gen_f',    label: 'Female' },
  { key: 'gen_skip', label: 'Prefer not to say' },
];

export const Q22_OPTIONS = [
  { key: 'edu_hs',    label: 'High school' },
  { key: 'edu_ba',    label: "Graduate / Bachelor's" },
  { key: 'edu_ma',    label: "Post Graduate / Master's" },
  { key: 'edu_phd',   label: 'PhD' },
  { key: 'edu_other', label: 'Other' },
];

// ── Helpers ──────────────────────────────────────────────────────────────────

// key → label  (for display)
export function labelOf(opts, key) {
  return opts.find(o => o.key === key)?.label ?? key;
}

// Build a label→key reverse map (used to normalise legacy DB rows)
export function reverseMap(opts) {
  return Object.fromEntries(opts.map(({ key, label }) => [label, key]));
}

// All option sets indexed by field name — used for bulk normalisation
export const OPTION_SETS = {
  q5:        Q5_OPTIONS,
  q6:        Q6_OPTIONS,
  q7:        Q7_OPTIONS,
  q8:        Q8_OPTIONS,
  q9:        Q9_OPTIONS,
  q_mindset: Q_MINDSET_OPTIONS,
  q10:       Q10_OPTIONS,
  q11:       Q11_OPTIONS,
  q12:       Q12_OPTIONS,
  q14:       Q14_OPTIONS,
  q15:       Q15_OPTIONS,
  q16:       Q16_OPTIONS,
  q18:       Q18_OPTIONS,
  q19:       Q19_OPTIONS,
  q20:       Q20_OPTIONS,
  q22:       Q22_OPTIONS,
};

// Fields stored as JSON arrays
export const ARRAY_FIELDS = new Set(['q10', 'q14', 'q18']);

// Normalise a single response row: convert any legacy label values to keys
export function normalizeRow(row) {
  const out = { ...row };
  for (const [field, opts] of Object.entries(OPTION_SETS)) {
    if (!out[field]) continue;
    const rev = reverseMap(opts);
    if (ARRAY_FIELDS.has(field)) {
      try {
        const arr = JSON.parse(out[field]) || [];
        out[field] = JSON.stringify(arr.map(v => rev[v] ?? v));
      } catch { /* leave as-is */ }
    } else {
      out[field] = rev[out[field]] ?? out[field];
    }
  }
  return out;
}
